import React from "react";
import { useTranslation } from "react-i18next";
import ReferenceListPage from "../components/ReferenceListPage";
import { departmentsAPI } from "../services/api";
import { loadDepartments } from "../store/slices/referenceDataSlice";
import { PERMISSIONS } from "../utils/permissions";

const DepartmentsPage = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <ReferenceListPage
      title={t("sidebar.departments")}
      api={departmentsAPI}
      reloadThunk={loadDepartments}
      requiredPermission={PERMISSIONS.MANAGE_DEPARTMENTS}
      onNavigate={onNavigate}
      columns={[
        { field: "department_id", label: "#" },
        { field: "name_en", label: t("referencePages.nameEn") },
        { field: "name_ar", label: t("referencePages.nameAr") },
        { field: "manager", label: t("referencePages.manager") },
        { field: "mobile", label: t("referencePages.mobile") },
        { field: "extension", label: t("referencePages.extension") },
      ]}
      formFields={[
        {
          name: "name_en",
          label: t("referencePages.nameEn"),
          required: true,
        },
        {
          name: "name_ar",
          label: t("referencePages.nameAr"),
          required: true,
        },
        {
          name: "manager",
          label: t("referencePages.manager"),
          required: true,
        },
        {
          name: "mobile",
          label: t("referencePages.mobile"),
          required: true,
        },
        {
          name: "extension",
          label: t("referencePages.extension"),
          required: true,
        },
      ]}
    />
  );
};

export default DepartmentsPage;
